import { create } from 'zustand';
import type { WallAnalyzeRequest } from './types';

interface WallState {
  request: WallAnalyzeRequest;
  setSection: (patch: Partial<WallAnalyzeRequest['section']>) => void;
  setMaterials: (patch: Partial<WallAnalyzeRequest['materials']>) => void;
  setLoads: (patch: Partial<WallAnalyzeRequest['loads']>) => void;
  setReinforcement: (patch: Partial<WallAnalyzeRequest['reinforcement']>) => void;
  /** Replace the active request — used when loading a saved design. */
  loadRequest: (req: WallAnalyzeRequest) => void;
}

const defaultRequest: WallAnalyzeRequest = {
  section: { lw: 400, tw: 20, hw: 250, lbe: 60 },
  materials: { fc: 210, fy: 4200, fyt: 4200, cover: 4 },
  loads: { Pu: 150_000, Mu: 20_000_000, Vu: 30_000 },
  reinforcement: {
    diam_be: '5/8',
    n_be_cols: 3,
    n_be_rows: 2,
    diam_v: '3/8',
    s_v: 25,
    n_layers: 2,
    diam_h: '3/8',
    s_h: 25,
    diam_stirrup_be: '3/8',
    s_stirrup_be: 10,
  },
};

export const useWallStore = create<WallState>((set) => ({
  request: defaultRequest,
  setSection: (patch) =>
    set((s) => ({ request: { ...s.request, section: { ...s.request.section, ...patch } } })),
  setMaterials: (patch) =>
    set((s) => ({ request: { ...s.request, materials: { ...s.request.materials, ...patch } } })),
  setLoads: (patch) =>
    set((s) => ({ request: { ...s.request, loads: { ...s.request.loads, ...patch } } })),
  setReinforcement: (patch) =>
    set((s) => ({
      request: { ...s.request, reinforcement: { ...s.request.reinforcement, ...patch } },
    })),
  loadRequest: (req) => set({ request: req }),
}));
